import $ from 'jquery';

if( $( '.filter-section' ).length ) {
  $( 'input[name="qp-filter-radio"]' ).on( 'change', ( elem ) => {
    const $this = $( elem.currentTarget );
    $( '.filter-container' ).addClass( 'hide' );
    $( `.${ $this.val() }` ).removeClass( 'hide' )

    $( '.floor-plans-grid' ).removeClass( 'show-less' );
    $( '#show-all' ).hide();
  } )
}